import { ThemeColors } from '~/themes/colors'

interface TextButtonColors {
  Text: {
    FontColor: ThemeColors
    Hover: {
      FontColor: ThemeColors
    }
    Active: {
      FontColor: ThemeColors
    }
  }
}
export const TextButtonColors: TextButtonColors = {
  Text: {
    FontColor: {
      default: 'blue.900',
    },
    Hover: {
      FontColor: {
        default: 'blue.700',
      },
    },
    Active: {
      FontColor: {
        default: 'blue.900',
      },
    },
  },
}
